// Helpers for talking to the service worker from app code. Currently
// just one shot — telling the SW to drop its form-templates cache after
// a create/update/delete so the picker on /tasks/create always sees the
// newest template without forcing the user to reload.

export const invalidateFormTemplatesCache = () => {
  try {
    if (typeof navigator === 'undefined') return
    if (!navigator.serviceWorker?.controller) return
    navigator.serviceWorker.controller.postMessage({
      type: 'INVALIDATE_FORM_TEMPLATES_CACHE',
    })
  } catch {
    /* SW not active — no-op */
  }
}
